import { useScroll } from 'epic-ue-ui';
import { useTransform, motion, useMotionValue } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`
    .gradient {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        background-image: url('https://cdn2.unrealengine.com/focus-gradient-2600x1463-20ebd93b51f4.png');
        background-position: center center;
    }
`;

export const MaskedHeaderGradient = ():JSX.Element => {
    const {position} = useScroll();
    const scrollY = useMotionValue(0);
    scrollY.set(position.y);

    //fade out the blue circle border
    const borderOpacity = useTransform(scrollY, [0, 200, 300], [1, 0.9, 0]);

    //scale up the blue circle border to make it look like the circle is getting larger
    const borderScale = useTransform(scrollY, [0, 200], [1, 1.3]);

    return (
        <Styled>
            <motion.div
                className="gradient will-change-opacity-transform"
                style={{
                    opacity: borderOpacity,
                    scale: borderScale
                }}
            />
        </Styled>
    );
}
